import { Slide } from 'pure-react-carousel';
import React from 'react';
import s from './slideStyles';
import Slide7 from './slide_7.svg';

export default ({ index }) => (
    <Slide className={s.slideWrapper} index={index}>
        <div className={s.imageWrapper}>
            <Slide7 />
        </div>
        <div className={s.textWrapper}>
            <p>
                If required each conclusion can be reviewed by your employees to
                validate the output.
            </p>
            <p>
                If there are any discrepancies or mistakes, the employee can go
                through the decision log to identify the root cause within a
                specific virtual expert and change the faulted information to
                ensure a correct outcome in the future.
            </p>
            <p>
                <em>Easy to scale and maintain. </em>
            </p>
        </div>
    </Slide>
);



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide7.component.js